import CCS from '@/assets/images/sponsors/spo-ccs-logo.webp'
import CompassDetroit from '@/assets/images/sponsors/Compass_Detroit_logo.webp'
import DetroitHackerHouse from '@/assets/images/sponsors/Detroit_Hacker_House.png'
import DTE from '@/assets/images/sponsors/spo-dte-logo.webp'
import GDGDetroit from '@/assets/images/sponsors/org-gdg-detroit.webp'
import GDGToledo from '@/assets/images/sponsors/org-gdg-toledo.webp'
import GDGWindsor from '@/assets/images/sponsors/org-gdg-windsor.webp'
import IBM from '@/assets/images/sponsors/IBM_logo.webp'
import NSBEDetroit from '@/assets/images/organizations/org-nsbe-logo.webp'
import SHPEDetroit from '@/assets/images/organizations/org-shpe-logo.webp'
import DevOpsDetroit from '@/assets/images/sponsors/DevOps_Detroit_Logo.webp'
import AED from '@/assets/images/sponsors/AED.webp'

// add these if you have them (update paths to match your repo)
import AutomationWorkz from '@/assets/images/sponsors/Automation_Workz.webp'

export const partnersData = {
  partners: [
    {
      id: 1,
      name: 'DTE',
      logo: DTE,
      desc: 'DTE Energy (NYSE: DTE) is a Detroit-based diversified energy company involved in the development and management of energy-related businesses and services nationwide. Its operating units include an electric company serving 2.3 million customers in Southeast Michigan and a natural gas company serving 1.3 million customers in Michigan. The DTE portfolio also includes non-utility businesses focused on industrial energy services, renewable natural gas, and energy marketing and trading.',
      url: 'https://www.dteenergy.com/',
    },
    {
      id: 2,
      name: 'Compass Detroit',
      logo: CompassDetroit,
      desc: 'The Collective of Minority Professionals and STEAM Societies (formerly COMPES) was formed in 2000 as an initiative between the NSBE, SHPE, and SWE Detroit professional chapters. The mission of this collaborative partnership is to support the local Detroit community in upskilling, career growth, networking, and to provide access to new opportunities.',
      url: 'https://compass-detroit.com/',
    },
    {
      id: 3,
      name: 'NSBE Detroit',
      logo: NSBEDetroit,
      desc: 'Representing Black Engineers in Detroit. NSBE Detroit Professionals strive to increase technical awareness, encourage scholastic achievement, and stimulate enthusiasm in the black engineering community of Detroit. NSBEs mission is to increase the number of culturally responsible Black engineers who excel academically, succeed professionally and positively impact the community. The NSBE Professionals inspire the next generation of technical professionals, and serve as a catalyst for transform.',
      url: 'https://nsbedetroitprofessionals.org/',
    },
    {
      id: 4,
      name: 'IBM',
      logo: IBM,
      desc: 'The mission of IBM is to be a catalyst that makes the world work better. We aim to have a positive impact globally, and in the communities where we operate, through business ethics, environmental commitment and responsible technology. For over a century, IBM been at the forefront of technological innovation. Beginning in the earliest days of computing, IBM has blended intelligence, innovation and science to improve business, society and the human experience.',
      url: 'https://www.ibm.com/us-en',
    },
    {
      id: 5,
      name: 'GDG Detroit',
      logo: GDGDetroit,
      desc: 'The Detroit Google Developers Group is an inclusive group that meets monthly online and in downtown Detroit to help educate and provide networking opportunities for software developers in the Detroit area.',
      url: 'https://gdg.community.dev/gdg-detroit/',
    },
    {
      id: 6,
      name: 'SHPE Detroit',
      logo: SHPEDetroit,
      desc: 'SHPE Detroit is transforming lives in Detroit by inspiring and motivating young Hispanic students to excel in STEM education through mentorship and community involvement and enhancing career opportunities for Hispanics by building a strong professional network.',
      url: 'https://www.shpedetroit.org/',
    },
    {
      id: 7,
      name: 'CCS',
      logo: CCS,
      desc: 'CCS provides students a rigorous and innovative education aligned with industry requirements. Our graduates are innovators, problem solvers and futurists who are prepared for a career, not just a job. CCS alumni know success. They are entrepreneurs. They are working artists. Fortune 500 companies hire them. The stories you will watch here are a testament to the impact CCS alumni are making in the art/design world. All of them dared to dream big. Let their stories inspire you.',
      url: 'https://www.ccsdetroit.edu/',
    },
    {
      id: 8,
      name: 'DevOps Detroit',
      logo: DevOpsDetroit,
      desc: 'DevOps Detroit is a nonprofit organization dedicated to empowering Detroit’s tech community through collaboration, education, and innovation. Founded with the mission of making Detroit a hub for DevOps excellence, we bring together professionals, students, and enthusiasts to share knowledge, build skills, and grow careers in cloud, DevOps, security, AI, and software development.',
      url: 'https://www.devopsdetroit.io/',
    },
    {
      id: 9,
      name: 'Automation Workz',
      logo: AutomationWorkz,
      desc: 'Automation Workz is a post-secondary tech certification school that uses video games to train students for certification exams in IoT, Cybersecurity, Network Engineering, Linux/Python, Analytics, Digital Marketing, and Fraud Examination, leading to jobs earning $40,000 to $90,000. Automation Workz can reskill your employees to seize the $9 trillion dollar Diversity Markets through scalable, customized services designed exclusively for your organization.',
      url: 'https://autoworkz.org/',
    },
    {
      id: 10,
      name: 'Detroit Hacker House',
      logo: DetroitHackerHouse,
      desc: 'Detroit Hacker House is where builders become founders. We run a residential accelerator and community programming designed to take you from idea to launched product.',
      url: 'https://detroithackerhouse.com',
    },
    {
      id: 11,
      name: 'Audio Engineers of Detroit',
      logo: AED,
      desc: 'Audio Engineers of Detroit provides many different audio recording services, including Commercial voice over, Audiobooks recording & Mastering, Podcast recording, Music recording, Stereo mixing, 7.1.4 Dolby Atmos Mixing, Audio mastering, Audio restoration, Location audio recording and audio-visual services.',
      url: 'https://aedetroit.com/',
    },
    {
      id: 12,
      name: 'GDG Toledo',
      logo: GDGToledo,
      desc: 'Google Developer Group Toledo is a community of developers interested in Google technologies.',
      url: 'https://gdg.community.dev/gdg-toledo/',
    },
    {
      id: 13,
      name: 'GDG Windsor',
      logo: GDGWindsor,
      desc: 'Google Developer Group Windsor is a community of developers interested in Google technologies.',
      url: 'https://gdg.community.dev/gdg-windsor/',
    },
  ],
}
